import { TableAction } from "../../../../components/ModularDataTable"
import type { PluginSpace } from "../types"



type ActionsFactoryParams = {
    onManageFeatures: (pluginspace: PluginSpace) => void
}

export function createActionsPluginSpace({ onManageFeatures }: ActionsFactoryParams): TableAction[] {


    const actions: TableAction[] = [
        {
            icon: 'fas fa-pen',
            label: 'Gerenciar Features',
            action: (item: PluginSpace) => onManageFeatures(item),
        },
    ]
    return actions
}